import { Injectable } from '@angular/core';
var RandomId = /** @class */ (function () {
    function RandomId() {
    }
    Object.defineProperty(RandomId.prototype, "generate", {
        get: function () {
            var id = (Math.random() + Date.now());
            return id;
        },
        enumerable: true,
        configurable: true
    });
    RandomId.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    RandomId.ctorParameters = function () { return []; };
    return RandomId;
}());
export { RandomId };
//# sourceMappingURL=random-id.js.map